export const ContactWhatsAppCta = () => (
  <section className="py-20 bg-[#F3F0EA]" data-testid="whatsapp-cta-section">
    <div className="max-w-4xl mx-auto px-6 sm:px-8 md:px-12 text-center">
      <h2 className="text-3xl font-bold text-stone-900 mb-4">
        ¿Prefieres escribirnos por WhatsApp?
      </h2>
      <p className="text-base text-stone-700 mb-8">
        Contáctanos directamente y recibe respuesta inmediata.
      </p>
      <a
        href="https://wa.me/17873625354"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block bg-[#25D366] hover:bg-[#20BD5A] text-white px-8 py-4 rounded-full font-semibold transition-all active:scale-95"
        data-testid="whatsapp-cta-button"
      >
        Escribenos por WhatsApp
      </a>
    </div>
  </section>
);
